import { createMemo, createSignal } from "solid-js";
import { routeData } from "~/routes/register";
import { useRouteData } from "solid-start";
import { get_options } from "~/utils/get_options";
import { For } from "solid-js";
import referral_addresses from "~/utils/refferrals";
import { VRSC_CURRENCY_ID } from "../CurrencyTable/Table";
import { getUpdateTime } from "./Register.server";
import ClickToCopy from "../ClickToCopy/ClickToCopy";
import { Tooltip } from "../Tooltip/Tooltip";

export default function Register() {
    const [name, setName] = createSignal<string>()
    const [primaryAddress, setPrimaryAddress] = createSignal<string>();
    const [referral, setReferral] = createSignal<string>();
    const [command1, setCommand1] = createSignal<string>();
    const [command2, setCommand2] = createSignal<string>();
    const [response, setResponse] = createSignal<string>();
    const [selectedCurrency, setSelectedCurrency] = createSignal<string>("VRSC");
    const [fetchingBlockHeight, setFetchingBlockHeight] = createSignal<boolean>(false);
    const [blockCount, setBlockCount] = createSignal<number>();

    const { referrals } = useRouteData<typeof routeData>();


    const handleSubmit = () => {
        if (!name() || !primaryAddress()) return alert("Please complete all required fields!");
        if (referral()) {
            if ((selectedCurrency() === 'VRSC') && !referral()?.endsWith('@')) return alert('Referrals for VRSC must end in @')
            else if ((selectedCurrency() !== 'VRSC') && !referral()?.endsWith(`.${selectedCurrency()}@`)) return alert(`Referrals for ${selectedCurrency()} must end in .${selectedCurrency()}@`)
        }
        let nameRegex = /(\w+)?([/:.*?"<>|@]+)(\w+)?/g;
        if (nameRegex.test(name() as string)) return alert('Name must not contain the following, "/ : * ? " < > | @"')
        const currCurrency = referrals()?.find((curr: any) => curr.namespace === selectedCurrency());
        const parent = currCurrency.parentid;
        setCommand1(`run registernamecommitment "${name()?.trim()}" "${primaryAddress()?.trim()}" "${referral()?.trim() || (currCurrency.referralid)}" "${parent}"`)
    }
    const parseResponse = (response: string) => {
        const stripped = response.replace(/\s+/g, '')
        const responseJSON = JSON.parse(stripped);
        const txid = responseJSON.txid;
        const primary_address = primaryAddress();
        const namereservation = responseJSON.namereservation;
        const _parent = selectedCurrency() !== 'VRSC' ? selectedCurrency() : "";
        if (namereservation) {
            const version = namereservation.version;
            const name = namereservation.name;
            const parent = namereservation.parent;
            const salt = namereservation.salt;
            const referral = namereservation.referral;
            const nameid = namereservation.nameid;
            setCommand2(`run registeridentity '{"txid":"${txid}","namereservation":{"version":1,"name":"${name}","parent":"${parent}","salt":"${salt}","referral":"${referral}"},"identity":{"name":"${name}","parent":"${_parent}","primaryaddresses":["${primary_address}"],"minimumsignatures":1}}'`);
        }
    }

    const handleSubmit1 = async () => {
        if (!response()) return;
        setFetchingBlockHeight(true)
        const int = setInterval(async () => {
            const d = await getUpdateTime();
            if (!blockCount()) setBlockCount(d[0].blockheight);
            if (d[0].blockheight > (blockCount() as number)) {
                clearInterval(int);
                setFetchingBlockHeight(false);
                parseResponse(response() as string)
            }
        }, 6000);
    }

    return (
        <form class="pagefooter-background shadow-md rounded px-8 pt-6 pb-8 mb-4 max-w-full">
            <div class="flex flex-col">
                <label class="block text-white text-sm font-bold mb-2" for="username">Select a Verus ID namespace:</label>
                <select class="shadow  border rounded w-full py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline" onChange={(e) => setSelectedCurrency(e.target.value)}>
                    <For each={referrals()}>
                        {(currency: any) => {
                            return (
                                <option value={currency.namespace}>{currency.namespace}</option>
                            )
                        }}
                    </For>
                </select>
                {(() => {
                    const curr = referrals()?.find((r) => r.namespace === selectedCurrency())
                    if (curr && curr.notes) {
                        return (
                            <div class="text-red-400">
                                {curr.notes}
                            </div>
                        );
                    }
                })()}
            </div>
            <div class="mb-4">
                <label class="block text-white text-sm font-bold mb-2" for="username">
                    Enter the name you would like to reserve:
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Your Sub ID" onChange={(e) => setName(e.target.value.trim())} />
            </div>
            <div class="mb-6">
                <label class="block text-white text-sm font-bold mb-2" for="primary_address">
                    Enter a Verus R-address you would like to set as your primary address:
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline" id="primary_address" type="text" placeholder="RGWym55BkmCXAUnM6eJkG7geWfzo62xFrP" onChange={(e) => setPrimaryAddress(e.target.value)} />
            </div>
            <div class="mb-6">
                <label class="block text-white text-sm font-bold mb-2" for="referral">
                    Do you have a referral ID? (If no, leave blank; we'll put one in for you!)
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline" id="referral" type="text" placeholder="VerusIDsdotcom@" onChange={(e) => setReferral(e.target.value)} />
            </div>
            <div class="flex items-center justify-between">
                <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={handleSubmit}>
                    Submit
                </button>
            </div>
            {command1() && (
                <div class="flex flex-col space-y-10">
                    <div class="flex flex-col space-y-2.5 max-w-[600px]">
                        <h6 class="mt-5 text-white text-base">Copy and paste the following command into your Verus wallet terminal:</h6>
                        <ClickToCopy text={command1() as string} />
                        <div class="flex items-end justify-center">
                            <img src='/arrowDown.svg' class="scale-[2]" />
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <h5 class="text-white text-base" style="margin-top: 27px;">**IMPORTANT**</h5>

                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <img src='/arrowDown.svg' class="scale-[2]" />
                        </div>


                        <h6 class="text-white text-base">After you run the command, copy and paste the response from the Verus wallet terminal into a Notepad or blank text file. You will need this information for the second step!</h6>

                    </div>
                    <img src="/Register_SubID_tip.png" class="h-[20rem] w-full " />
                    <div>
                        <label class="block text-white text-sm font-bold mb-2" for="referral">
                            Paste the full response below:
                        </label>
                        <input class="shadow appearance-none border border-red-500 rounded py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline w-full" id="response1" type="text" placeholder="Paste your response here" onChange={(e) => setResponse(e.target.value)} />
                        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={handleSubmit1}>
                            Submit
                        </button>
                    </div>
                    {fetchingBlockHeight() && <div class="flex flex-col items-center justify-center w-full space-y-3">
                        <span class="text-white">
                            Waiting for blockchain confirmations.
                        </span>
                        <div class='h-[50px] w-[50px] rounded-lg overflow-hidden'>
                            <img src='/loading_anim.gif' alt='loading' width='75px' height='50px' />
                        </div>
                        <span class="text-white">
                            This may take up to 10 minutes.
                        </span>
                    </div>}
                    {command2() && (
                        <div class="max-w-[600px]">
                            <h6 class="mt-5 text-white text-base">Copy and paste the following command into your Verus wallet terminal:</h6>
                            <ClickToCopy text={command2() as string} />
                        </div>
                    )}
                </div>
            )}
        </form>
    )
}